/* eslint-disable import/no-named-as-default */
/* eslint-disable prettier/prettier */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from 'react-i18next';
import Avatar from "@material-ui/core/Avatar";
import axios from "axios";
import Timer from "../Timer/Timer";
import fetchConfig from "../../Constants/fetch";
import LanguageSelector from "../LanguageSelector/LanguageSelector";

// TODO: Fix this, this is temporary fix
import {
  PMZoneLogo,
  Polygon,
  TrianglePause,
  PauseIcon,
} from "../../Constants/assets";

import { centerContent } from "../../Constants/styles";
import { getFullNameAbbreviation } from "../../utils/global";

// Stylings
const Header = styled.header`
  ${centerContent}

  height: 54px;
  /* opacity: 0.7; */
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.21);
  background-color: rgba(255, 255, 255, 0.6);
  position: absolute;
  width: 100%;
  z-index: 105;
`;

const InnerContainer = styled.div`
  display: flex;
  width: 93.4%;
  align-self: center;
  align-items: center;
  justify-content: space-between;
`;
const PauseGameContainer = styled.div`
  width: 100px;
  height: 40px;
  display: flex;
  justify-content: space-evenly;
  z-index: 105;
`;
const Button = styled.span`
  background: #ebeced;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
// Sub components
const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ProfileName = styled.span`
  padding-right: 17px;
`;
const SubscriptionContainer = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.2;
  padding-right: 17px;
`;
const SubscriptionLabel = styled.span`
  white-space: nowrap;
`;
const SubscriptionDate = styled.span`
  white-space: nowrap;
  margin-top: 4px;
`;
const DropDown = styled.div`
  position: absolute;
  border-radius: 8px;
  transform: translate(-5em, 3em);
  background: #ffffff;
  width: 192px;
  height: 57px;
  align-items: center;
  justify-content: center;
  z-index: 100;
  list-style: none;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
`;
const DropDownContainer = styled.div`
  cursor: pointer;
  width: 80%;
  margin: auto;
`
function UserProfile({
  Name = "lonely planet",
  canPlayUntil,
  prevReportPopUp,
  togglePopUp,
  isGamePaused,
  languagesList,
  setCurrentLanguage,
  currentLanguage,
  shortCutLanguage,
}) {
  const [openMenu, setOpenMenu] = useState(false);
  const { t } = useTranslation();
  const formattedCanPlayUntil = (() => {
    if (!canPlayUntil) return null;
    const parsedDate = new Date(canPlayUntil);
    if (Number.isNaN(parsedDate.getTime())) return null;
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    }).format(parsedDate);
  })();
  useEffect(() => {
    const closeOpenMenus = (e) => {
      const dropDownElem = document.getElementById('DropDown');
      // Check if the click was outside the dropdown
      if (dropDownElem && !dropDownElem.contains(e.target)) {
        setOpenMenu(false);
      }
    };

    // Add event listener to listen to clicks on the document
    document.addEventListener("click", closeOpenMenus);

    return () => {
      // Cleanup by removing the event listener
      document.removeEventListener("click", closeOpenMenus);
    };
  }, [openMenu]);

  return (
    <>
      <LanguageSelector style={{ position: 'relative', marginRight: '30px' }}
        languages={languagesList}
        isGamePaused={isGamePaused}
        setCurrentLanguage={setCurrentLanguage}
        currentLanguage={currentLanguage}
        shortCutLanguage={shortCutLanguage}
      />
      {formattedCanPlayUntil && (
        <SubscriptionContainer>
          <SubscriptionLabel>Subscription ends:</SubscriptionLabel>
          <SubscriptionDate>{formattedCanPlayUntil}</SubscriptionDate>
        </SubscriptionContainer>
      )}
      <AvatarWrapper id="DropDown">
        <ProfileName>
          {Name.charAt(0).toUpperCase() + Name.slice(1)}
        </ProfileName>
        {/* FIXME: We need to fetch that color from our theme */}
        <Avatar style={{ background: "#007A9E" }}>
          {getFullNameAbbreviation(Name)}
        </Avatar>

        <Polygon
          style={{
            paddingLeft: "11px",
            width: "11px",
            boxSizing: "initial",
            cursor: "pointer",
          }}
          onClick={() => {
            if (!isGamePaused) {
              setOpenMenu(!openMenu);
            }
          }}
        />

        {openMenu && !isGamePaused && (
          <DropDown>
            <DropDownContainer
              onClick={() => {
                togglePopUp(true);
                setOpenMenu(!openMenu);
              }}
            >
              {t(`modals.previous_games.info_title`)}
            </DropDownContainer>
          </DropDown>
        )}
      </AvatarWrapper>
    </>
  );
}

// const Logo = styled(PMZoneLogo);

const sendPauseGameCodeToDB = async (reason, timeSeconds, gameId, userId) => {
  let result;
  const gameRunTimeSeconds = `0${Math.floor(timeSeconds % 60)}`.slice(-2);
  const gameRunTimeMinutes = `0${Math.floor((timeSeconds / 60) % 60)}`.slice(
    -2
  );
  const gameRunTimeHours = `0${Math.floor((timeSeconds / 3600) % 60)}`.slice(
    -2
  );
  const gameRunTime = `${gameRunTimeHours}:${gameRunTimeMinutes}:${gameRunTimeSeconds}`;
  try {
    result = await axios.get(`${fetchConfig.prefix}/game/pause_game_function`, {
      params: {
        reason,
        timer: gameRunTime,
        gameId,
        userId,
      },
    });
  } catch (e) {
    console.log(e);
  }
  return result.data;
};

function TopBar({
  playerName,
  canPlayUntil,
  togglePopUp,
  prevReportPopUp,
  clearTimer,
  toggleClearTimer,
  timeSeconds,
  setTimeSeconds,
  hasBeenMadeRestartGame,
  setHasBeenMadeRestartGame,
  resetTimer,
  toggleResetTimer,
  toggleIsGamePaused,
  isGamePaused,
  gameId,
  userId,
  localTimerOfPreviousGame,
  setLocalTimerOfPreviousGame,
  position,
  pauseForPlanningTimer,
  planningTimerBaselineRev = 0,
  updatePlanningTimer,
  isGameStarted,
  gameStartTime,
  totalTimeoutDuration,
  isGamePausedRef,
  languagesList,
  setCurrentLanguage,
  currentLanguage,
  shortCutLanguage,
}) {
  const [clicked, setClicked] = useState(false);
  const [cursorType, setCursorType] = useState("pointer");
  const [pause, setPause] = useState(false);

  const showDevGameId =
    window.location.hostname === "localhost" ||
    window.location.hostname === "pmzone.dml.co.il" ||
    window.location.hostname === "almost.pmzone.com";

  return (
    <Header id="main-game-header">
      <InnerContainer>
        <PMZoneLogo />
        <PauseGameContainer>
          {isGamePaused && (
            <Button
              disabled={clicked}
              style={{
                cursor: cursorType,
              }}
              onClick={async () => {
                if (!clicked) {
                  setPause(false);
                  setClicked(true);
                  setCursorType("no-drop");
                  toggleIsGamePaused(
                    await !sendPauseGameCodeToDB(
                      "user clicked stop pause on the top bar button",
                      timeSeconds,
                      gameId,
                      userId
                    )
                  );
                  setTimeout(() => {
                    setClicked(false);
                    setCursorType("pointer");
                  }, 200);
                }
              }}
            >
              <TrianglePause />
            </Button>
          )}
          {!isGamePaused && (
            <Button
              disabled={clicked}
              style={{
                cursor: cursorType,
              }}
              onClick={async () => {
                if (!clicked) {
                  setPause(true);
                  setClicked(true);
                  setCursorType("no-drop");
                  toggleIsGamePaused(
                    await sendPauseGameCodeToDB(
                      "user clicked start pause on the top bar button",
                      timeSeconds,
                      gameId,
                      userId
                    )
                  );
                  setTimeout(() => {
                    setClicked(false);
                    setCursorType("pointer");
                  }, 200);
                }
              }}
            >
              <PauseIcon />
            </Button>
          )}
        </PauseGameContainer>
        <Timer
          clearTimer={clearTimer}
          toggleClearTimer={toggleClearTimer}
          timeSeconds={timeSeconds}
          setTimeSeconds={setTimeSeconds}
          hasBeenMadeRestartGame={hasBeenMadeRestartGame}
          setHasBeenMadeRestartGame={setHasBeenMadeRestartGame}
          resetTimer={resetTimer}
          toggleResetTimer={toggleResetTimer}
          localTimerOfPreviousGame={localTimerOfPreviousGame}
          setLocalTimerOfPreviousGame={setLocalTimerOfPreviousGame}
          position={position}
          isGamePaused={isGamePaused}
          pauseForPlanningTimer={pauseForPlanningTimer}
          planningTimerBaselineRev={planningTimerBaselineRev}
          updatePlanningTimer={updatePlanningTimer}
          isGameStarted={isGameStarted}
          gameStartTime={gameStartTime}
          totalTimeoutDuration={totalTimeoutDuration}
          isGamePausedRef={isGamePausedRef}
          gameId={showDevGameId ? gameId : undefined}
        />
        <UserProfile
          Name={playerName}
          canPlayUntil={canPlayUntil}
          togglePopUp={togglePopUp}
          prevReportPopUp={prevReportPopUp}
          isGamePaused={isGamePaused}
          languagesList={languagesList}
          setCurrentLanguage={setCurrentLanguage}
          currentLanguage={currentLanguage}
          shortCutLanguage={shortCutLanguage}
        />
      </InnerContainer>
    </Header>
  );
}

export default TopBar;
